import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { BuildingService, MemberService } from '../data';
import { Building } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RoomBookingValidators {

  constructor(
    private buildingService: BuildingService,
    private memberService: MemberService,
  ) {
  }

  checkRoomEmpty(form: FormGroup) {
    return () => {
      if (!form.controls['startDate']?.value ||
        !form.controls['endDate']?.value ||
        !form.controls['guestsNumber']?.value) {
        return null;
      }

      const buildingId = (this.memberService.getCurrentUser().workplace as Building).id;
      const from = new Date(form.controls['startDate'].value);
      const to = new Date(form.controls['endDate'].value);
      const capacity = form.controls['guestsNumber'].value;
      const excludedBooking = form.get('id')?.value ?? null;

      return timer(500)
        .pipe(
          switchMap(() => this.buildingService.getEmptyRooms(buildingId, from, to, capacity, excludedBooking)),
          map(rooms => rooms.some(room => room.resourceName === form.get('room').value)),
          map(roomEmpty => roomEmpty ? null : {checkRoomEmpty: true}),
        );
    };
  }
}
